<template>
  <div>
    <a-modal
      :title="dataForm.id ? '编辑数据' : '新增数据'"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      :keyboard="false"
      :maskClosable="false"
      @cancel="handleCancel"
      :getContainer="getContainer"
    >
      <a-form-model
        ref="ruleForm"
        :model="dataForm"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="名称" prop="title">
          <a-input v-model="dataForm.title" placeholder="请输入名称" />
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-input v-model="dataForm.remark" placeholder="请输入备注" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
  
<script>
import { Userinfo } from "@/request/login";
import {
  addConfigDetail,
  editConfigDetail,
  configDetailInfo,
} from "@/request/config";
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      replaceFields: { children: "children", title: "title", key: "id" },
      treeData: [],
      dataForm: {
        id: "",
        pid: "",
        project_id: "",
        title: "",
        remark: "",
      },
      bf: {},
      rules: {
        role_name: [
          { required: true, message: "请输入角色名称", trigger: "change" },
        ],
        role_menu: [
          {
            type: "array",
            required: true,
            message: "请分配角色功能权限",
            trigger: "change",
          },
        ],
      },
    };
  },
  beforeMount() {
    this.bf = JSON.parse(JSON.stringify(this.dataForm));
  },
  methods: {
    //id是detail表的id pid是config表id
    init(id = "", pid = "") {
      this.visible = true;
      this.dataForm.pid = pid;
      if (id) {
        this.dataForm.id = id;
        this.getInfo();
      }
    },
    getInfo() {
      configDetailInfo(this.dataForm.id).then((res) => {
        this.dataForm = { ...res.data };
      });
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          const fn = this.dataForm.id ? editConfigDetail : addConfigDetail;
          fn(this.dataForm)
            .then((res) => {
              this.$message.success(
                this.dataForm.id ? "修改数据成功" : "新增数据成功"
              );
              this.handleCancel();
              this.$emit("ok");
            })
            .finally(() => {
              let a = setTimeout(() => {
                clearTimeout(a);
                this.confirmLoading = false;
              }, 500);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      console.log("Clicked cancel button");
      this.$refs.ruleForm.resetFields();
      this.dataForm = JSON.parse(JSON.stringify(this.bf));
      this.treeData = [];
      this.visible = false;
    },
    //切换角色
    roleChange(e) {
      this.dataForm.role_id = e;
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    }
  },
};
</script>
  
<style></style>